import { content as kiWhatsappContent } from './blog-content/ki-whatsapp-automatisierung-rebooking'
import { content as crmSechsstelligeContent } from './blog-content/crm-system-sechsstellige-monatsumsaetze'
import { content as coldEmailContent } from './blog-content/idealer-cold-email-prozess-9-schritte'
import { content as menschlicheFehlerContent } from './blog-content/menschliche-fehler-vertrieb-automatisierung'
import { content as crmSetupContent } from './blog-content/3-schritte-ideales-crm-setup'
import { content as noShowContent } from './blog-content/no-show-quote-reduzieren-70-prozent'
import { content as crmAutomatisierungenContent } from './blog-content/7-crm-automatisierungen-vertriebsleistung-verdoppeln'
import { content as hyperpersonalisierungContent } from './blog-content/zukunft-vertrieb-hyperpersonalisierung-ki-agenten'
import { content as closeReviewContent } from './blog-content/close-com-crm-review-2026'
import { content as kiCrmSucheContent } from './blog-content/ki-gesteuerte-crm-suche-close-com'
import { content as hubspotVsCloseContent } from './blog-content/hubspot-vs-close-crm-vergleich'
import { content as closeVsUmsatzContent } from './blog-content/close-vs-umsatz-io-vergleich'
import { content as skoolMemberContent } from './blog-content/skool-member-zu-hochpreiskunden'
import { content as crmFehlerContent } from './blog-content/11-fatale-crm-implementierungs-fehler'
import { content as dreiWegeVergleichContent } from './blog-content/close-umsatz-hubspot-3-wege-vergleich'
import { content as vertriebsteamsContent } from './blog-content/10-unterschiede-erfolgreiche-vertriebsteams'

export interface BlogPost {
  id: string
  slug: string
  title: {
    de: string
    en: string
  }
  excerpt: {
    de: string
    en: string
  }
  content: {
    de: string
    en: string
  }
  author: {
    name: string
    role: string
  }
  publishedAt: string
  readTime: string
  category: {
    de: string
    en: string
  }
  image?: string
}

export const blogPosts: BlogPost[] = [
  {
    id: '17',
    slug: '10-unterschiede-erfolgreiche-vertriebsteams',
    title: {
      de: '10 Unterschiede zwischen erfolgreichen und erfolglosen Vertriebsteams',
      en: '10 Differences Between Successful and Unsuccessful Sales Teams',
    },
    excerpt: {
      de: 'Nach über 60 Vertriebsteam-Analysen habe ich 10 fundamentale Unterschiede zwischen Teams entdeckt, die kontinuierlich skalieren, und Teams, die nicht weiterkommen. Entdecke diese Unterschiede und wie Du sie implementierst.',
      en: "After over 60 sales team analyses, I've discovered 10 fundamental differences between teams that continuously scale and teams that don't progress. Discover these differences and how to implement them.",
    },
    category: {
      de: 'Vertriebsteam-Management',
      en: 'Sales Team Management',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-11-19',
    readTime: '13 Min.',
    content: vertriebsteamsContent,
  },
  {
    id: '16',
    slug: 'close-umsatz-hubspot-3-wege-vergleich',
    title: {
      de: 'Close vs. Umsatz.io vs. HubSpot: Der ultimative 3-Wege-Vergleich 2024',
      en: 'Close vs. Umsatz.io vs. HubSpot: The Ultimate 3-Way Comparison 2024',
    },
    excerpt: {
      de: 'Close, Umsatz.io oder HubSpot? In diesem ultimativen Vergleich zeige ich Dir alle Unterschiede zwischen den drei führenden CRM-Systemen. Nach über 60 Implementierungen kenne ich jeden Vorteil, jeden Nachteil und jede versteckte Kostenfalle.',
      en: "Close, Umsatz.io, or HubSpot? In this ultimate comparison, I'll show you all the differences between the three leading CRM systems. After over 60 implementations, I know every advantage, every disadvantage, and every hidden cost trap.",
    },
    category: {
      de: 'CRM-Vergleich',
      en: 'CRM Comparison',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-11-20',
    readTime: '16 Min.',
    content: dreiWegeVergleichContent,
  },
  {
    id: '15',
    slug: '11-fatale-crm-implementierungs-fehler',
    title: {
      de: '11 fatale CRM-Implementierungs-Fehler, die Dich Umsatz kosten (und wie Du sie vermeidest)',
      en: '11 Fatal CRM Implementation Mistakes That Cost You Revenue (And How to Avoid Them)',
    },
    excerpt: {
      de: 'Du implementierst gerade ein neues CRM-System? Diese 11 Fehler kosten Dich massiv Umsatz – wenn Du sie nicht vermeidest. Nach über 60 CRM-Implementierungen zeige ich Dir die häufigsten Fehler und wie Du sie vermeidest.',
      en: "Are you currently implementing a new CRM system? These 11 mistakes cost you massive revenue – if you don't avoid them. After over 60 CRM implementations, I'll show you the most common mistakes and how to avoid them.",
    },
    category: {
      de: 'CRM-Implementierung',
      en: 'CRM Implementation',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-11-21',
    readTime: '15 Min.',
    content: crmFehlerContent,
  },
  {
    id: '14',
    slug: 'skool-member-zu-hochpreiskunden',
    title: {
      de: 'Von kostenlosem Skool-Member zu Hochpreiskunden: Der systematische Prozess',
      en: 'From Free Skool Member to High-Ticket Customers: The Systematic Process',
    },
    excerpt: {
      de: 'Du hast eine Skool-Community mit kostenlosen Mitgliedern – aber wie konvertierst Du sie systematisch zu zahlenden Hochpreiskunden? Entdecke den exakten 3-Phasen-Prozess.',
      en: 'You have a Skool community with free members – but how do you systematically convert them into paying high-ticket customers? Discover the exact 3-phase process.',
    },
    category: {
      de: 'Community-Vertrieb',
      en: 'Community Sales',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-11-22',
    readTime: '10 Min.',
    content: skoolMemberContent,
  },
  {
    id: '13',
    slug: 'close-vs-umsatz-io-vergleich',
    title: {
      de: 'Close vs. Umsatz.io: Der ehrliche Vergleich – Vertriebsoptimierung vs. Datenprotokollierung',
      en: 'Close vs. Umsatz.io: The Honest Comparison – Sales Optimization vs. Data Logging',
    },
    excerpt: {
      de: 'Close oder Umsatz.io? Das ist wie Photoshop mit einem Rechnungstool zu vergleichen. Entdecke den fundamentalen Unterschied zwischen beiden Systemen – und für wen welches Tool wirklich geeignet ist.',
      en: "Close or Umsatz.io? It's like comparing Photoshop with an invoicing tool. Discover the fundamental difference between both systems – and who each tool is really suitable for.",
    },
    category: {
      de: 'CRM-Vergleich',
      en: 'CRM Comparison',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-11-23',
    readTime: '12 Min.',
    content: closeVsUmsatzContent,
  },
  {
    id: '12',
    slug: 'hubspot-vs-close-crm-vergleich',
    title: {
      de: 'HubSpot vs. Close CRM: Der ultimative Vergleich 2024 – Welches CRM ist das Richtige für Dich?',
      en: 'HubSpot vs. Close CRM: The Ultimate Comparison 2024 – Which CRM is Right for You?',
    },
    excerpt: {
      de: 'Du stehst vor der Entscheidung: HubSpot oder Close CRM? In diesem umfassenden Vergleich zeige ich Dir alle Vor- und Nachteile beider Systeme – damit Du die richtige Entscheidung für Dein Unternehmen triffst.',
      en: "You're facing the decision: HubSpot or Close CRM? In this comprehensive comparison, I'll show you all the pros and cons of both systems – so you can make the right decision for your company.",
    },
    category: {
      de: 'CRM-Vergleich',
      en: 'CRM Comparison',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-11-27',
    readTime: '14 Min.',
    content: hubspotVsCloseContent,
  },
  {
    id: '11',
    slug: 'ki-gesteuerte-crm-suche-close-com',
    title: {
      de: 'KI-gesteuerte CRM-Suche: Wie Close.com die Vertriebsarbeit revolutioniert',
      en: 'AI-Powered CRM Search: How Close.com is Revolutionizing Sales Work',
    },
    excerpt: {
      de: 'Close.com hat eine bahnbrechende Funktion eingeführt: KI-gestützte Suche. Entdecke, wie diese Innovation die Art und Weise revolutioniert, wie Du mit Deinem CRM arbeitest – ohne technische Kenntnisse.',
      en: 'Close.com has introduced a groundbreaking feature: AI-powered search. Discover how this innovation revolutionizes the way you work with your CRM – without technical knowledge.',
    },
    category: {
      de: 'KI & CRM',
      en: 'AI & CRM',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-12-02',
    readTime: '8 Min.',
    content: kiCrmSucheContent,
  },
  {
    id: '10',
    slug: 'ki-whatsapp-automatisierung-rebooking',
    title: {
      de: 'KI-WhatsApp-Automatisierung: 40-50% mehr Termine durch automatisches Rebooking',
      en: 'AI WhatsApp Automation: 40-50% More Appointments Through Automatic Rebooking',
    },
    excerpt: {
      de: 'Entdecke, wie KI-WhatsApp-Automatisierung 40-50% der abgesagten Termine automatisch rettet – vollständig ohne Zeitaufwand Deines Vertriebsteams.',
      en: 'Discover how AI WhatsApp automation automatically saves 40-50% of cancelled appointments – completely without time investment from your sales team.',
    },
    category: {
      de: 'WhatsApp Automatisierung',
      en: 'WhatsApp Automation',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-11-28',
    readTime: '9 Min.',
    content: kiWhatsappContent,
  },
  {
    id: '1',
    slug: 'crm-system-sechsstellige-monatsumsaetze',
    title: {
      de: 'Wie dein CRM-System über sechsstellige Monatsumsätze entscheidet',
      en: 'How Your CRM System Determines Six-Figure Monthly Revenue',
    },
    excerpt: {
      de: 'Dein CRM-System kann darüber entscheiden, ob du auf mehrfach sechsstellige Monatsumsätze skalierst – oder ob du im Datenchaos Leads verlierst.',
      en: 'Your CRM system can determine whether you scale to six-figure monthly revenue – or lose leads in data chaos.',
    },
    category: {
      de: 'CRM-Strategie',
      en: 'CRM Strategy',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-12-07',
    readTime: '8 Min.',
    content: crmSechsstelligeContent,
  },
  {
    id: '2',
    slug: 'idealer-cold-email-prozess-9-schritte',
    title: {
      de: 'Der ideale Cold-Email-Prozess: 9 Schritte für erfolgreiche Kaltakquise per E-Mail',
      en: 'The Ideal Cold Email Process: 9 Steps for Successful Cold Email Outreach',
    },
    excerpt: {
      de: 'Cold-Email-Kampagnen können extrem effektiv sein – oder deine Domain komplett ruinieren. Der Unterschied liegt im Prozess. Entdecke die 9 essentiellen Schritte für erfolgreiche Cold Emails.',
      en: 'Cold email campaigns can be extremely effective – or completely ruin your domain. The difference lies in the process. Discover the 9 essential steps for successful cold emails.',
    },
    category: {
      de: 'Cold Email',
      en: 'Cold Email',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-12-01',
    readTime: '12 Min.',
    content: coldEmailContent,
  },
  {
    id: '3',
    slug: 'menschliche-fehler-vertrieb-automatisierung',
    title: {
      de: 'Warum menschliche Fehler im Vertrieb dich Millionen kosten – und wie Automatisierung hilft',
      en: 'Why Human Errors in Sales Cost You Millions – And How Automation Helps',
    },
    excerpt: {
      de: 'Menschliche Fehler im Vertrieb können dich extrem viel Umsatz kosten. Entdecke die kritischsten Fehler und wie du sie durch intelligente Automatisierung eliminierst.',
      en: 'Human errors in sales can cost you massive revenue. Discover the most critical mistakes and how to eliminate them through intelligent automation.',
    },
    category: {
      de: 'Automatisierung',
      en: 'Automation',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-12-05',
    readTime: '9 Min.',
    content: menschlicheFehlerContent,
  },
  {
    id: '4',
    slug: '3-schritte-ideales-crm-setup',
    title: {
      de: 'Die 3 Schritte zum idealen CRM-Setup: So läuft die Zusammenarbeit ab',
      en: 'The 3 Steps to the Ideal CRM Setup: How the Collaboration Works',
    },
    excerpt: {
      de: 'Von der ersten Analyse bis zur langfristigen Betreuung: Ein detaillierter Einblick in den bewährten 3-Schritte-Prozess für dein optimales CRM-System.',
      en: 'From initial analysis to long-term support: A detailed insight into the proven 3-step process for your optimal CRM system.',
    },
    category: {
      de: 'CRM-Setup',
      en: 'CRM Setup',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-12-06',
    readTime: '7 Min.',
    content: crmSetupContent,
  },
  {
    id: '5',
    slug: 'no-show-quote-reduzieren-70-prozent',
    title: {
      de: 'Die unterschätzte KPI: So reduzierst du deine No-Show-Quote um bis zu 70%',
      en: 'The Underestimated KPI: How to Reduce Your No-Show Rate by Up to 70%',
    },
    excerpt: {
      de: 'No-Shows kosten dich massiv Umsatz. Entdecke die 7 Hauptgründe für No-Shows und die bewährten Strategien, um deine No-Show-Quote drastisch zu reduzieren.',
      en: 'No-shows cost you massive revenue. Discover the 7 main reasons for no-shows and proven strategies to drastically reduce your no-show rate.',
    },
    category: {
      de: 'Vertriebsoptimierung',
      en: 'Sales Optimization',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-12-03',
    readTime: '11 Min.',
    content: noShowContent,
  },
  {
    id: '6',
    slug: '7-crm-automatisierungen-vertriebsleistung-verdoppeln',
    title: {
      de: '7 CRM-Automatisierungen, die deine Vertriebsleistung mehr als verdoppeln',
      en: '7 CRM Automations That More Than Double Your Sales Performance',
    },
    excerpt: {
      de: 'Als offizieller Close Partner zeige ich dir die sieben stärksten CRM-Automatisierungen, die bei meinen Kunden nachweislich zu massiven Umsatzsteigerungen geführt haben.',
      en: 'As an official Close Partner, I show you the seven most powerful CRM automations that have demonstrably led to massive revenue increases for my clients.',
    },
    category: {
      de: 'Automatisierung',
      en: 'Automation',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-12-04',
    readTime: '10 Min.',
    content: crmAutomatisierungenContent,
  },
  {
    id: '9',
    slug: 'zukunft-vertrieb-hyperpersonalisierung-ki-agenten',
    title: {
      de: 'Die Zukunft des Vertriebs: Hyperpersonalisierung mit KI-Agenten',
      en: 'The Future of Sales: Hyperpersonalization with AI Agents',
    },
    excerpt: {
      de: 'Die Zukunft des Vertriebs liegt in der Hyperpersonalisierung mit KI-Agenten. Entdecke verschiedene Szenarien, Vorteile und konkrete Implementierungsbeispiele.',
      en: 'The future of sales lies in hyperpersonalization with AI agents. Discover various scenarios, benefits, and concrete implementation examples.',
    },
    category: {
      de: 'KI & Automatisierung',
      en: 'AI & Automation',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-11-29',
    readTime: '10 Min.',
    content: hyperpersonalisierungContent,
  },
  {
    id: '8',
    slug: 'close-com-crm-review-2026',
    title: {
      de: 'Close.com CRM Review 2026: Das beste CRM für Coaches und Agenturen?',
      en: 'Close.com CRM Review 2026: The Best CRM for Coaches and Agencies?',
    },
    excerpt: {
      de: 'Als offizieller Close Partner und nach über 60 CRM-Implementierungen gebe ich dir ein vollständiges Review von Close.com – mit allen Features, Benefits, Nachteilen und einer ehrlichen Meinung.',
      en: 'As an official Close Partner and after over 60 CRM implementations, I give you a complete review of Close.com – with all features, benefits, drawbacks, and an honest opinion.',
    },
    category: {
      de: 'CRM-Review',
      en: 'CRM Review',
    },
    author: {
      name: 'Justus Kraft',
      role: 'CRM-Experte',
    },
    publishedAt: '2024-11-30',
    readTime: '15 Min.',
    content: closeReviewContent,
  },
]

export function getBlogPosts(): BlogPost[] {
  return blogPosts.sort(
    (a, b) =>
      new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  )
}

export function getBlogPost(slug: string): BlogPost | undefined {
  return blogPosts.find((post) => post.slug === slug)
}
